module.exports = __webpack_public_path__ + "img/home-index-menu10.fc007e9c.png";